<template>
    <sui-label v-if="tag" v-bind:style="{ backgroundColor: tag.color, color: '#FFF' }">{{ tag.name }}</sui-label>
</template>

<style>
    .tag-pill {
        border-radius: 5px;
        color: white;
        padding: 6px;
        margin-right: 5px;
        font-weight: 600;
    }

</style>

<script>
    export default {
        name: 'TagPill',
         props: {
            tagId: Number,
            tagCollection: Array,
        }, 
        data() {
            return {
                tag: null,
            }
        },
        created() {
            this.findTag();
        },
        methods: {
            findTag() {
                this.tag = this.tagCollection.find(t => t.id === this.tagId);
            }
        }
    }
</script>